<div class="row search-bar">
    <div class="col-md-4">
        <div class="form-group has-feedback  input-group">
            <input (keyup.enter)="runSearch()" [(ngModel)]="search" type="text"
                   class="form-control has-feedback has-clear" id="search"
                   style="font-family: Helvetica, FontAwesome" placeholder="&#xF002; Search Permit Review">
            <i *ngIf="search !== undefined && search !== ''"
               (click)="search = ''; runSearch();"
               class="fa fa-times form-control-feedback"
         style="padding-top:10px; z-index:10; pointer-events: auto; cursor:pointer; position: absolute; right: 50px;"></i>
                <span class="input-group-btn">
            <button type="button" class="btn btn-primary" (click)="runSearch()">
                <i class="fa fa-search"></i>
            </button>
            </span>
        </div>
    </div>
    <div class="col-md-1" style="padding-top:6px; padding-left:0; width:0;">
        <app-help-docs-links recordType="search" color="#333333"></app-help-docs-links>
    </div>
</div>

<div class="panel-body" style="background:none;">
    <div class="row">
        <div class="col-md-12">
            <h3 *ngIf="searchObj.status === 'issued'" style="margin:10px 0px">Permits Ready for Notification</h3>
            <h3 *ngIf="searchObj.status === ''" style="margin:10px 0px">All Permits</h3>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <span *ngIf="searchObj.status === 'issued'"></span>
            <span *ngIf="searchObj.status === ''">(<a style="cursor: pointer" (click)="toggleAll()">View Only Permits Ready for Notification</a>)</span>
            <app-results-list [service]="permitService" [displayFields]="display_fields" [showLink]="true" [rowButtons]="rowButtons"
                            inputType="none" [searchObj]="searchObj" ></app-results-list>
        </div>
    </div>
</div>

